export function blur(target) {
  target?.blur?.()
}

export function focus(target) {
  target?.focus?.()
}
